import { Empresa } from '../shared/entity/Empresa';
import { FindManyReq, FindOneReq } from '../shared/types/TypeormTypes';
import api from './api';
import { SERVER_URL } from '../shared/constants';
import { GetManyParams, GetOneParams } from '../shared/types/TypeormTypes';

const BASE_URL = '/empresa';

class empresaApi {
  async getOne(query: GetOneParams<Empresa>) {
    try {
      let res = await this.getMany({ ...query, take: 1 });
      if (!res.length) {
        throw new Error('Empresa não encontrada.');
      }
      return res[0];
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getMany(query: GetManyParams<Empresa>) {
    try {
      let res = await api.post<Empresa[]>(BASE_URL + '/get', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async count(query: GetManyParams<Empresa>) {
    try {
      let res = await api.post<number>(BASE_URL + '/count', { query });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async update(where: Partial<Empresa>, update: Partial<Empresa>) {
    try {
      let res = await api.put(BASE_URL, { update }, { params: where });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async insert(empresa: Partial<Empresa>) {
    try {
      let res = await api.post(BASE_URL, { empresa });
      let data = res.data;
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async getImagem(id: number) {
    try {
      let res = await api.get(BASE_URL + '/imagem', {
        params: { id },
        responseType: 'arraybuffer'
      });

      let blob = new Blob([res.data], {
        type: res.headers['content-type']
      });

      let imagem = new File([blob], 'produto.png');

      return imagem;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  getUrlSomNotificacao() {
    return SERVER_URL + BASE_URL + '/somNotificacao';
  }
}

export default new empresaApi();
